import { CALL_API } from './../../middlewares/api';

const onLoadListRoles = () => ({
  [CALL_API]: {
    type: 'ADMIN_LIST_ROLES',
    endpoint: 'admin',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'roles' }
    }
  }
});

const onLoadListWebhook = () => ({
  [CALL_API]: {
    type: 'WEBHOOK_LIST_TYPE_EVENT_USERS',
    endpoint: 'webhook',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'type_event_users' }
    }
  }
});

const onChangeListWebhook = (status, type_status) => dispatch => ({ value }) => dispatch({
  [CALL_API]: {
    type: 'WEBHOOK_STATUS_TYPE_EVENT_USERS',
    endpoint: 'webhook',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: {
        type: 'type_event_users',
        id: value.id
      },
      body: {
        status,
        type_status
      }
    }
  },
  value: {
    value,
    status,
    type_status
  }
});

const onChangeRoleAcesso = ({status, value, ...otherProps}) => ({
  [CALL_API]: {
    type: 'ADMIN_STATUS_ROLES',
    endpoint: 'acessos',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: {
        id: value.id
      },
      body: {
        ...otherProps,
        status,
        seguranca: value.id_usuario
      }
    }
  },
  value: {
    value,
    status
  }
});

const onChangeRoleAcessoAdmin = ({status, value, ...otherProps}) => ({
  [CALL_API]: {
    type: 'ADMIN_STATUS_ROLES',
    endpoint: 'admin',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: {
        type: 'roles',
        id: value.id
      },
      body: {
        ...otherProps,
        status,
        seguranca: value.id_usuario
      }
    }
  },
  value: {
    value,
    status
  }
});

const onChangeListRoles = status => dispatch => value =>
  dispatch(onChangeRoleAcessoAdmin({status, ...value}));

const onLoadListRolesContratantes = () => ({
  [CALL_API]: {
    type: 'ADMIN_LIST_ROLES_CONTRATANTES',
    endpoint: 'admin',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: {
        type: 'roles_contratantes'
      }
    }
  }
});

const onChangeListRolesContratantes = status => dispatch => ({ value }) =>
  dispatch({
    [CALL_API]: {
      type: 'ADMIN_STATUS_ROLES_CONTRATANTES',
      endpoint: 'admin',
      authenticated: true,
      config: {
        method: 'PUT',
        querystring: {
          type: 'roles_contratantes',
          id: value.id
        },
        body: {
          status
        }
      }
    },
    value: {
      value,
      status
    }
  });

const onLoadListContratantes = () => ({
  [CALL_API]: {
    type: 'ADMIN_LIST_CONTRATANTES',
    endpoint: 'admin',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'contratantes' }
    }
  }
});

const onChangeListContratantes = status => dispatch => ({ value }) =>
dispatch({
  [CALL_API]: {
    type: 'ADMIN_STATUS_CONTRATANTES',
    endpoint: 'admin',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: {
        type: 'contratantes',
        id: value.id
      },
      body: {
        status
      }
    }
  },
  value: {
    value,
    status
  }
});

const onLoadCountErrors = () => ({
  [CALL_API]: {
    type: "COUNT_ERROS",
    endpoint: 'errors',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: {count:"pending"}
    }
  }
});

const onLoadListPendencias = () => ({
  [CALL_API]: {
    type: "LIST_PENDENCIAS_ADMINISTRACAO",
    endpoint: 'admin',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'pendencias' }
    }
  }
});

const onChangeListPendencias = status => dispatch => ({ value }) => 
dispatch({
  [CALL_API]: {
    type: "LIST_PENDENCIAS_ADMINISTRACAO",
    endpoint: 'admin',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'pendencias' }
    }
  },
  value: {
    value,
    status
  }
});

const onLoadListaContatosIfNeeded = () => ({
  [CALL_API]: {
    type: "LIST_CONTATOS_ADMINISTRACAO",
    endpoint: 'unidades',
    authenticated: true,
    config: {
      method: 'GET'
    }
  }
});

const onLoadListaContatos = () => (dispatch, getState) => {
  const { fetching, errors } = getState().admin.contatos;

  if (!fetching && !errors.length) {
    return dispatch(onLoadListaContatosIfNeeded());
  }

  return Promise.resolve();
};

const onLoadListaAcessos = () => ({
  [CALL_API]: {
    type: "LIST_ACESSOS_ADMINISTRACAO",
    endpoint: 'acessos',
    authenticated: true,
    config: {
      method: 'GET'
    }
  }
});

export default {
  onLoadListPendencias,
  onChangeListPendencias,
  onLoadListRoles,
  onChangeRoleAcesso,
  onChangeListRoles,
  onLoadCountErrors,
  onLoadListWebhook,
  onChangeListWebhook,
  onLoadListContratantes,
  onChangeListContratantes,
  onLoadListRolesContratantes,
  onChangeListRolesContratantes,
  onLoadListaContatos,
  onLoadListaAcessos
};



// WEBPACK FOOTER //
// ./src/modules/admin/actions.js